import {
  Directive,
  ElementRef,
  Renderer2,
  HostListener,
  Input
} from '@angular/core';

@Directive({
    selector: '[dipseWebMetricEvent]',
    standalone: false
})
export class WebMetricEventDirective {
  @Input() dipseWebMetricEvent: string;

  constructor(private renderer: Renderer2, private hostElement: ElementRef) {}

  @HostListener('click')
  onMouseEnter() {
    if (typeof window[ 'trackCustomLink' ] === 'function') {
      const tagName = this.hostElement.nativeElement.attributes[ 0 ].ownerElement.nodeName.toLowerCase() === 'button' ? 'Button' : 'Link';
      window[ 'trackCustomLink' ](this.dipseWebMetricEvent, tagName, 'onClick');
    }
  }
}
